export namespace TimeControl {
  export namespace Plugin {
    export const Name = 'timeControl';

    export interface PublicAPI {
      [Plugin.Name]: API;
    }
  }

  export interface API {
    get: () => TimeControl.Model | null;
    set: (timeControl: TimeControl.Model | null) => void;
    getType: () => void;
  }

  export interface Model {
    baseTime: number;
    increment: number;
  }

  export enum Types {
    Blitz = 'blitz',
    Bullet = 'bullet',
    Rapid = 'rapid',
  }

  export const enum Header {
    Null = '-',
    Separator = '+',
    TimePerMove = '/',
    Unset = '?',
  }
}
